import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { XCircle } from 'lucide-react';

const DonationCancelled = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-50 to-white px-4">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-xl p-10 text-center" data-testid="donation-cancelled-page">
        <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <XCircle className="w-9 h-9 text-amber-600" />
        </div>
        <h1 className="text-2xl font-bold text-gray-900 mb-3">Donation Cancelled</h1>
        <p className="text-gray-600 mb-8">
          Your donation was not completed and no payment was taken. You're welcome to try again whenever you're ready.
        </p>
        <Link to="/">
          <Button className="bg-blue-600 hover:bg-blue-700" data-testid="cancelled-home-button">
            Return to Home
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default DonationCancelled;
